import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "max-content",
    width: "100%",
    padding: props.matches ? "3rem 7rem" : "1rem",
    paddingBottom: 0,
    color: theme.darkSlateGrayColor,
    backgroundColor: theme.whiteColor,
  }),
  categories: {
    position: "absolute",
    top: "3rem",
    left: "7rem",
    display: "flex",
    alignItems: "center",
    color: theme.darkSlateGrayColor,
    fontFamily: theme.fontFamilyQuestrial,
    "& > span": {
      textDecoration: "underline",
    },
  },
  title: (props: any) => ({
    textTransform: "uppercase",
    fontSize: props.matches ? "1.5rem" : "1rem",
    fontWeight: 500,
  }),
  functionBar: (props: any) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: props.matches ? "3rem" : "1rem",
    width: "100%",
    textTransform: "uppercase",
    padding: props.matches ? "1rem 0" : "0.6rem 0",
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRight: "none",
    borderLeft: "none",
  }),
  contentContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  toggleBtn: (props: any) => ({
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    textTransform: "uppercase",
    fontSize: props.matches ? "1rem" : "0.8rem",
    fontFamily: theme.fontFamilyArchivo,
    fontWeight: 400,
    padding: 0,
  }),
  collectionContainer: (props: any) => ({
    display: "grid",
    gridGap: props.matches ? "2rem" : "1rem",
    gridTemplateColumns: props.matches
      ? "repeat(auto-fill, minmax(18rem, 1fr))"
      : "repeat(auto-fill, minmax(8rem, 1fr))",
    justifyItems: "center",
    width: "100%",
    height: "max-content",
    paddingBottom: props.matches ? "3rem" : "1rem",
    paddingTop: props.matches ? "3rem" : "1rem",
  }),
  noItemsFoundContainer: {
    marginTop: "3rem",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  brandImg: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "5rem",
    color: theme.whiteColor,
    gridRow: "1",
    gridColumn: "1 / -1",
    width: "100%",
    height: "15rem",
    backgroundColor: theme.blanchedAlmondColor,
    background:
      'url("https://i.picsum.photos/id/1062/5092/3395.jpg?hmac=o9m7qeU51uOLfXvepXcTrk2ZPiSBJEkiiOp-Qvxja-k") no-repeat center center',
    backgroundSize: "cover",
  },
}));

export default useStyles;
